// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const SET_APP_USER = 'SET_APP_USER';
export const SET_APP_USER_LOADING = 'SET_APP_USER_LOADING';
